'use strict';

const css = require('@mindmup/mapjs/src/dom/css'),
	attr = require('@mindmup/mapjs/src/dom/attr'),
	px = require('@mindmup/mapjs/src/dom/px'),
	fakeDIVDOM = document.createElement('div');

attr(fakeDIVDOM, {'data-mm-role': 'storyboard-sizer', 'class': 'storyboard-scene-title', 'box-sizing': 'border-box'});
css(fakeDIVDOM, {'z-index': '-99', 'visibility': 'hidden'});

module.exports = function storyboardFontSize(title, widthCss, heightCss) {
	const width = parseFloat(widthCss),
		height = parseFloat(heightCss),
		result = {fontSize: height * 0.5 },
		multiplier = 0.9,
		shouldResize = () => {
			return (fakeDIVDOM.offsetHeight > height || fakeDIVDOM.scrollWidth > width) && result.fontSize > height / 30;
		};
	if (!Number.isFinite(width) || !Number.isFinite(height) || !width || width < 0 || !height || height < 0) {
		throw new Error('invalid-args');
	}
	css(fakeDIVDOM, {'max-width': px(width)});
	fakeDIVDOM.innerText = title;
	document.body.append(fakeDIVDOM);

	do {
		result.fontSize = Math.floor(result.fontSize * multiplier);
		result.lineHeight = Math.floor(result.fontSize * 1.3);
		css(fakeDIVDOM, {
			'font-size': px(result.fontSize),
			'line-height': px(result.lineHeight)
		});
	} while (shouldResize());
	result.textWidth = fakeDIVDOM.offsetWidth;
	fakeDIVDOM.remove();
	return result;
};
